import { render, staticRenderFns } from "./TextConfigView.vue?vue&type=template&id=817025f6"
import script from "./TextConfigView.vue?vue&type=script&lang=js"
export * from "./TextConfigView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports